module.exports = __webpack_public_path__ + "res/reel.e6c37b09862e36da281e8d85f68e705d.webp";